import { AnyAction } from 'redux'
import * as actionType from './types'

export const showConfirmDeletePostModal = (post:any): AnyAction => ({ type: actionType.SHOW_CONFIRM_DELETE_POST_MODAL, payload: post })
export const closeConfirmDeletePostModal = (): AnyAction => ({ type: actionType.CLOSE_CONFIRM_DELETE_POST_MODAL })
export const setConfirmDeletePostIsLoading = (value:any): AnyAction => ({ type: actionType.SET_CONFIRM_DELETE_POST_MODAL_IS_LOADING, payload: value })
